import React from "react";
import ReactDOM from "react-dom";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "@fortawesome/fontawesome-free/css/all.min.css";
import App from "./App";
import "./index.scss";
import "socicon/css/socicon.css";
import store, { persistor } from "app/store/store";
import "_metronic/_assets/plugins/line-awesome/css/line-awesome.css";
import "_metronic/_assets/plugins/flaticon/flaticon.css";
import "_metronic/_assets/plugins/flaticon2/flaticon.css";
import "./css/colors.css";
import "./css/theme.css";

const { PUBLIC_URL } = process.env;

if (process.env.REACT_APP_MOCK_PAINEL_OFERTA !== "false") {
  require("./app/mocks/painelOferta/instalar").instalarMocksDoPainelDeOfertas();
}

ReactDOM.render(
  <App store={store} persistor={persistor} basename={PUBLIC_URL} />,
  document.getElementById("root")
);
